// Copyright 2026. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { COLORS } from 'admin/core/theme';

export const TitleContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
`;

export const TitleRow = styled.div`
    display: flex;
    align-items: baseline;
    gap: 8px;
    flex-wrap: wrap;
`;

export const BreadcrumbLink = styled(Link)`
    font-size: 26px;
    font-weight: 700;
    color: ${COLORS.PRIMARY};
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;

export const BreadcrumbSep = styled.span`
    font-size: 22px;
    color: ${COLORS.GREY_60};
    font-weight: 400;
`;

export const DomainName = styled.span`
    font-size: 26px;
    font-weight: 700;
    color: ${COLORS.GREY_100};
`;

export const SubTitleRow = styled.div`
    margin-top: 4px;
    display: flex;
    align-items: center;
    gap: 16px;
    font-size: 13px;
    color: ${COLORS.GREY_70};
`;

export const LocationName = styled.span`
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const ActionsContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const ActiveLabel = styled.span`
    font-size: 13px;
    color: ${COLORS.GREY_80};
`;

export const DocumentationLink = styled.a`
    font-size: 13px;
    color: ${COLORS.PRIMARY};
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 4px;

    &:hover {
        text-decoration: underline;
    }
`;
